var map = {
	"./icons8-appliances-50.png": "f9aa",
	"./icons8-bed-50.png": "ea59",
	"./icons8-bench-press-50.png": "6cef",
	"./icons8-blender-50.png": "83d9",
	"./icons8-books-100.png": "7e85",
	"./icons8-camera-addon-identification-50.png": "afbc",
	"./icons8-camping-tent-16.png": "6cbe",
	"./icons8-chandelier-80.png": "675c",
	"./icons8-clothes-25.png": "c4a8",
	"./icons8-collectibles-50.png": "4025",
	"./icons8-dish-91.png": "bd85",
	"./icons8-dress-front-view-50.png": "42ea",
	"./icons8-drill-64.png": "7bb5",
	"./icons8-easel-50.png": "2970",
	"./icons8-formal-outfit-50.png": "ffb2",
	"./icons8-golf-clubs-50.png": "b562",
	"./icons8-guitar-64.png": "913b",
	"./icons8-hair-dryer-50.png": "16f1a",
	"./icons8-handbag-50.png": "f277",
	"./icons8-hdtv-80.png": "f71a",
	"./icons8-home-decoration-66.png": "cb7c",
	"./icons8-housekeeping-32.png": "803d",
	"./icons8-jewelry-32.png": "49ff",
	"./icons8-lawn-mower-64.png": "1c24",
	"./icons8-office-50.png": "6d8d",
	"./icons8-open-box-50.png": "cab1",
	"./icons8-pet-bowl-64.png": "f683",
	"./icons8-sofa-50.png": "24af",
	"./icons8-vacuum-cleaner-50.png": "c987",
	"./icons8-wheelchair-64.png": "939e",
	"./icons8-women-shoe-100.png": "4122"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";